import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const TipoRegistroFormGroup = ({ iValue }) => {
  return (
    <Form.Group className='mt-2'>
      <Col md={6}>
        <Field name='tipoRegistro'>
          {({ field }) => (
            <Form.Radio
              {...field}
              id='tipo-registro-ingreso'
              value='INGR'
              label='INGRESO'
              checked={iValue === 'INGR'}
            />
          )}
        </Field>
      </Col>
      <Col md={6}>
        <Field name='tipoRegistro'>
          {({ field }) => (
            <Form.Radio
              {...field}
              id='tipo-registro-cancelacion'
              value='BUSQ'
              label='BUSQUEDA'
              checked={iValue === 'BUSQ'}
            />
          )}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoRegistroFormGroup)
